export type CardItem = {
  id: number;
  groupId: number;
  name: string;
  description: string;
  icon: JSX.Element;
  mode: string;
  url: string;
};

export type Tabs = {
  id: number;
  name: string;
};

export type GenerationError = {
  error: string;
};

export enum AlertType {
  Info = 'info',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}

export type Alert = {
  type: AlertType;
  message: string;
};

export type Generation = {
  texts: string[];
  features?: { key: string; keyword: string }[];
  message: string;
};

export enum Mode {
  Review = 'review',
  Mail = 'mail',
  Website = 'website',
  ProductCategory = 'product_category',
  Blog = 'blog',
  Instagram = 'instagram',
  Wildberries = 'wildberries',
  ProductDescription = 'product_description',
  Rutube = 'rutube_description',
  RutubeReview = 'rutube_review',
}

export type Modes = string[];

export type Generations = {
  [key: string]: {};
};

export type UserInput = {
  mode: Mode;
  [key: string]: string | number | string[];
};

export type GenerationId = {
  id: string;
  credits_used: number;
  free_generations_used: number;
  timeout: number;
};

export enum UserType {
  Reqular = 'regular',
  Enterprise = 'enterprise',
}

export enum SubscriptionStatus {
  Active = 'active',
  Trialing = 'trialing',
  Canceled = 'canceled',
}

export type Subscription = {
  id: string;
  created: number;
  current_period_start: number;
  current_period_end: number;
  trial_start?: number;
  trial_end?: number;
  status: SubscriptionStatus;
  credits: {
    total: number;
    used: number;
  };
  product_id: string;
  product_name: string;
  amount: number;
  interval: string;
  forever_free?: boolean;
  cancel_at_period_end?: boolean;
  default_payment_method?: string;
};

export type User = {
  id: string;
  username: string;
  email: string;
  email_verified: boolean;
  type: UserType;
  created: string;
  provider: string | null;
  credits: {
    total: number;
    used: number;
  };
  subscriptions: Subscription[];
  free_tier: {
    first_usage_in_period: string;
    total_generations: number;
    used_generations: number;
    // availableGenerations: number;
  };
};

export enum ChatUserRole {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
}

export type ChatMessage = {
  role: ChatUserRole;
  content: string;
};

export type Input = {
  [key: string]: string;
};

export type OutboundMessage = {
  message: Input;
};

export type ChatMessages = ChatMessage[];

export enum ConversationStatus {
  Generating = 'generating',
  Done = 'done',
  Error = 'error',
}

export type Conversation = {
  id: string;
  status: ConversationStatus;
  creation_date: string;
  edit_date: string;
  messages: ChatMessages;
};
